import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Session } from 'globals/interfaces';

export const initialState = {
  sessions: [],
  isSuccess: false,
};

const sessionListSlice = createSlice({
  name: 'sessions',
  initialState,
  reducers: {
    startSession: (state, { payload }) => state,
    stopSession: (state, { payload }) => state,
    updateSession: (state, { payload }: PayloadAction<Session[]>) => {
      const mergedSessions = payload.map(newSession => {
        const existingSession = state.sessions.find(s => s.session_id === newSession.session_id);
        if (!('is_secondary_disabled' in newSession) && existingSession && typeof existingSession.is_secondary_disabled !== 'undefined') {
          return { ...newSession, is_secondary_disabled: existingSession.is_secondary_disabled };
        }
        return newSession;
      });
      state.sessions = mergedSessions;
      state.isSuccess = true;
      return state;
    },
  },
});

export const { startSession, stopSession, updateSession } = sessionListSlice.actions;

export const selectSessionById = (state, sessionId) => {
  return state.sessions.find((session) => session.session_id === sessionId);
};

export const selectConfigurationBySessionId = (state, sessionId) =>{
  return selectSessionById(state, sessionId)?.configuration;
}

export default sessionListSlice.reducer;
